import { style, styleVariants } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'
import { ButtonVariation } from './ButtonVariation'

export const button = style({
  display: 'inline-flex',
  borderRadius: vars.buttons.radius,
  alignItems: 'center',
  gap: 10,
  height: 48,
  boxSizing: 'border-box',
  boxShadow: '0px 5px 18px rgba(9, 53, 70, 0.08)',
  transition: '0.3s all',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  padding: '0 32px',
  fontSize: 16,
  lineHeight: 1,
  fontWeight: 500,
  textDecoration: 'none',
  maxWidth: '100%',
  border: 'none'
})

export const buttonVariants = styleVariants({
  [ButtonVariation.Primary]: {
    background: vars.color.dark,
    color: vars.color.white,
    ':hover': {
      color: vars.color.white,
      background: vars.color.darkLighter
    }
  },
  [ButtonVariation.PrimaryInversed]: {
    background: vars.color.darkLighter,
    border: `2px solid ${vars.color.darkLighter}`,
    color: vars.color.white,
    ':hover': {
      color: vars.color.white,
      background: vars.color.dark
    }
  },
  [ButtonVariation.Secondary]: {
    background: vars.color.white,
    border: `2px solid ${vars.color.dark}`,
    color: vars.color.dark,
    ':hover': {
      borderColor: vars.color.darkLighter,
      color: vars.color.darkLighter
    }
  },
  [ButtonVariation.Neutral]: {
    background: vars.color.mediumLighter,
    border: `2px solid ${vars.color.mediumLighter}`,
    color: vars.color.dark,
    ':hover': {
      borderColor: vars.color.darkLighter,
      color: vars.color.darkLighter
    }
  },
  [ButtonVariation.Danger]: {
    background: vars.color.danger,
    color: vars.color.white,
    ':hover': {
      color: vars.color.danger,
      background: vars.color.dangerLighter
    }
  },
  [ButtonVariation.DangerInversed]: {
    background: vars.color.white,
    border: `2px solid ${vars.color.danger}`,
    color: vars.color.danger,
    ':hover': {
      borderColor: vars.color.dangerLighter,
      background: vars.color.dangerLighter
    }
  },
  [ButtonVariation.Success]: {
    background: vars.color.success,
    color: vars.color.white,
    ':hover': {
      color: vars.color.success,
      background: vars.color.successLighter
    }
  },
  [ButtonVariation.Link]: {
    background: 'transparent',
    color: vars.color.dark,
    boxShadow: 'none',
    padding: '0 !important', // Override the padding from the button component
    textDecoration: 'underline',
    ':hover': {
      color: vars.color.darkLighter
    }
  },
  [ButtonVariation.AI]: {
    background: vars.color.ai,
    color: vars.color.white,
    ':hover': {
      background: vars.color.darkLighter
    }
  },
  [ButtonVariation.Light]: {
    background: vars.color.white,
    color: vars.color.darkLighter,
    boxShadow: vars.shadowLight,
    ':hover': {
      background: vars.color.darkLighter,
      color: vars.color.white
    }
  }
})

export const buttonExtraSmall = style({
  height: 29,
  gap: 6,
  padding: '0 12px',
  fontSize: 14
})

export const buttonSmall = style({
  height: 36,
  padding: '0 14px'
})

export const buttonNarrow = style({
  padding: '0 16px',
  selectors: {
    [`&${buttonExtraSmall}`]: {
      padding: '0 6px'
    }
  }
})

export const buttonShrink = style({
  padding: '0 12px',
  selectors: {
    [`&${buttonExtraSmall}`]: {
      padding: '0 6px'
    }
  }
})

export const buttonFullWidth = style({
  width: '100%',
  justifyContent: 'center'
})

export const buttonDisabled = style({
  color: vars.color.medium,
  background: vars.color.mediumLighter,
  cursor: 'not-allowed',
  boxShadow: 'none'
})

export const buttonDisabledActive = style({
  color: vars.color.medium,
  background: vars.color.darkLighter,
  cursor: 'not-allowed',
  boxShadow: 'none'
})

export const buttonIcon = style({
  fontSize: '1.2em'
})
